<template>
  <section class="inner-page">
    <h4>Alterar Password</h4>
    <input placeholder="Password Actual" type="password">
    <input placeholder="Nova Password" type="password">
    <input placeholder="Confirmar Nova Password" type="password">
    <elvas-button :button="{title: 'guardar'}" @click.native="save()"/>
  </section>
</template>
<script>
import ElvasButton from '../../../components/elvas-button.vue'
export default {
  data () {
    return {
      current_password: null,
      password: null,
      password_confirmation: null
    }
  },
  methods: {
    async save () {
      let data = await this.api.put('user', {current_password: this.current_password, password: this.password, password_confirmation: this.password_confirmation})
    }
  }
}
</script>